import React from "react";
import { HREF } from "../../db";
import { Link } from "react-router-dom";

function Awarded() {
  return (
    <React.Fragment>
      <div className="local fl">
        <h3>研究成果</h3>
        <div className="dqwz fr">
          当前位置：
          <Link to={HREF.INDEX}>主页</Link>&gt;
          <Link to={HREF.PUBLICATION}>研究成果</Link>&gt;
          <Link to={HREF.PUBLICATION_AWARDED}>奖项</Link>
        </div>
      </div>
      <div className="cy-title fl">
        <ul>
          <li>
            <Link to={HREF.PUBLICATION_PAPER}>论文</Link>
          </li>
          <li>
            <Link to={HREF.PUBLICATION_PATENT}>专利</Link>
          </li>
          <li>
            <Link to={HREF.PUBLICATION_AWARDED} className="ej-current">
              奖项
            </Link>
          </li>
        </ul>
      </div>
      <div className="Publications fl">
        <div className="Publications-con fl">
          <div id="vsb_content_1946_u51">
            <div id="vsb_content">
              <p>
                <span style={{ fontFamily: "tahoma", fontSize: "16px" }}>
                  <strong>孔祥杰获奖情况:</strong>
                </span>
              </p>
              <p>
                <span style={{ fontFamily: "tahoma", fontSize: "16px" }}>
                  • 2021年 中国计算机学会杰出会员
                </span>
              </p>
              <p>
                <span style={{ fontFamily: "tahoma", fontSize: "16px" }}>
                  • 2020年 浙江省杰出青年基金获得者
                </span>
              </p>
              <p>
                <span style={{ fontFamily: "tahoma", fontSize: "16px" }}>
                  • 2020年 IEEE 车载技术协会（VTS）地面交通最佳论文奖（Best Land Transport）
                </span>
              </p>
              <p>
                <span style={{ fontFamily: "tahoma", fontSize: "16px" }}>
                  • 2020年 辽宁省计算机学会学术年会优秀论文二等奖
                </span>
              </p>
              <p>
                <span style={{ fontFamily: "tahoma", fontSize: "16px" }}>
                  • 2020年 孔祥杰获大连理工大学本科生优秀毕业论文指导老师
                </span>
              </p>
              <p>
                <span style={{ fontFamily: "tahoma", fontSize: "16px" }}>
                  • 2019年 IEEE Access 国际期刊2018年杰出编委
                </span>
              </p>
              <p>
                <span style={{ fontFamily: "tahoma", fontSize: "16px" }}>
                  • 2019年 辽宁省自然科学学术成果奖二等奖
                </span>
              </p>
              <p>
                <span style={{ fontFamily: "tahoma", fontSize: "16px" }}>
                  • 2019年 孔祥杰获大连理工大学优秀研究生教学成果奖
                </span>
              </p>
              <p>
                <span style={{ fontFamily: "tahoma", fontSize: "16px" }}>
                  • 2018年 Outstanding Reviewer of JOURNAL OF ISA TRANSACTIONS
                </span>
              </p>
              <p>
                <span style={{ fontFamily: "tahoma", fontSize: "16px" }}>
                  • 2018年 Journal of The Franklin Institute国际期刊2017年杰出审稿人
                </span>
              </p>
              <p>
                <span style={{ fontFamily: "tahoma", fontSize: "16px" }}>
                  • 2018年 ISA Transactions国际期刊2017年杰出审稿人
                </span>
              </p>
              <p>
                <span style={{ fontFamily: "tahoma", fontSize: "16px" }}>
                  • 2018年 Outstanding Reviewer of JOURNAL OF THE FRANKLIN
                  INSTITUTE
                </span>
              </p>
              <p>
                <span style={{ fontFamily: "tahoma", fontSize: "16px" }}>
                  • 2018年 Outstanding Associate Editor of 2018 for IEEE Access
                </span>
              </p>
              <p>
                <span style={{ fontFamily: "tahoma", fontSize: "16px" }}>
                  • 2018年 辽宁省自然科学学术成果奖三等奖
                </span>
              </p>
              <p>
                <span style={{ fontFamily: "tahoma", fontSize: "16px" }}>
                  • 2017年  IEEE Senior Member
                </span>
              </p>
              <p>
                <span style={{ fontFamily: "tahoma", fontSize: "16px" }}>
                  • 2017年 辽宁省自然科学学术成果奖一等奖
                </span>
              </p>
              <p>
                <span style={{ fontFamily: "tahoma", fontSize: "16px" }}>
                  • 2017年 大连理工大学教学质量优良奖
                </span>
              </p>
              <p>
                <span style={{ fontFamily: "tahoma", fontSize: "16px" }}>
                  • 2017年 辽宁省自然科学学术成果奖一等奖
                </span>
              </p>
              <p>
                <span style={{ fontFamily: "tahoma", fontSize: "16px" }}>
                  • 2017年 大连理工大学本科生优秀毕业论文指导老师
                </span>
              </p>
              <p>
                <span style={{ fontFamily: "tahoma", fontSize: "16px" }}>
                  • 2016年 辽宁省自然科学学术成果奖一等奖
                </span>
              </p>
              <p>
                <span style={{ fontFamily: "tahoma", fontSize: "16px" }}>
                  • 2016年 大连理工大学教学质量优良奖 校级
                </span>
              </p>
              <p>
                <span style={{ fontFamily: "tahoma", fontSize: "16px" }}>
                  • 2016年 辽宁省自然科学学术成果奖一等奖
                </span>
              </p>
              <p>
                <span style={{ fontFamily: "tahoma", fontSize: "16px" }}>
                  • 2016年
                  第九届全国高校计算机网络教学暨网络工程专业建设研讨会优秀论文二等奖
                </span>
              </p>
              <p>
                <span style={{ fontFamily: "tahoma", fontSize: "16px" }}>
                  • 2015年 大连理工大学软件学院青年教师讲课竞赛二等奖 校级
                </span>
              </p>
              <p>
                <span style={{ fontFamily: "tahoma", fontSize: "16px" }}>
                  • 2015年 夏锋、孔祥杰、杨卓、陈志奎、姚琳
                  辽宁省教育教学信息化大赛二等奖 省级
                </span>
              </p>
              <p>
                <span style={{ fontFamily: "tahoma", fontSize: "16px" }}>
                  • 2014年 夏锋、李杰、郝若男、孔祥杰
                  辽宁省自然科学学术成果奖三等奖 省级
                </span>
              </p>
              <p>
                <span style={{ fontFamily: "tahoma", fontSize: "16px" }}>
                  • 2014年 大连理工大学软件学院优秀党员 校级
                </span>
              </p>
              <p>
                <span style={{ fontFamily: "tahoma", fontSize: "16px" }}>
                  • 2014年 H3C网络学院优秀讲师 校级
                </span>
              </p>
              <p>
                <span style={{ fontFamily: "tahoma", fontSize: "16px" }}>
                  • 2013年 大连理工大学教学质量优良奖 校级
                </span>
              </p>
              <p>
                <span style={{ fontFamily: "tahoma", fontSize: "16px" }}>
                  • 2013年 大连理工大学本科生优秀毕业论文指导老师 校级
                </span>
              </p>
              <p>
                <span style={{ fontFamily: "tahoma", fontSize: "16px" }}>
                  • 2012年 大连理工大学教学质量优良奖 校级
                </span>
              </p>
              <p>
                <span style={{ fontFamily: "tahoma", fontSize: "16px" }}>
                  • 2012年 大连理工大学优秀硕士学位论文指导老师 校级
                </span>
              </p>
              <p>
                <span style={{ fontFamily: "tahoma", fontSize: "16px" }}>
                  • 2011年 大连理工大学优秀班主任 校级
                </span>
              </p>
              <p>
                <span style={{ fontFamily: "tahoma", fontSize: "16px" }}>
                  • 2011年 大连理工大学本科生优秀毕业论文指导老师 校级
                </span>
              </p>
              <p>
                <span style={{ fontFamily: "tahoma", fontSize: "16px" }}>
                  • 2010年 大连理工大学研究生精品课程 主讲人 校级
                </span>
              </p>
              <p>
                <span style={{ fontFamily: "tahoma", fontSize: "16px" }}>
                  • 2010年 大连理工大学本科生优秀毕业论文指导老师 校级
                </span>
              </p>
            </div>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
}

export { Awarded };
